module.exports = __webpack_public_path__ + "static/img/paper@2x.a2fef61.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/img_red_packet/paper@2x.png
// module id = YG9Z
// module chunks = 69